<template>
    <div class="preview-section-content">
        <div class="preview-section-content-left">
            <van-image fit="cover" :src="dataItem.cover_img" />
            <img class="live-image-type" v-if="dataItem.type == 2" src="/static/v4/assembly/icon_list_tag_column.svg" alt="" />
            <img v-else-if="dataItem.live_status == 0" class="live-image-type" src="/static/img/live/icon_list_tag_live_count_down.svg" alt="" />
            <img v-else-if="dataItem.live_status == 1" class="live-image-type" src="/static/img/live/icon_list_tag_live_process.svg" alt="" />
            <img v-else-if="dataItem.live_status > 1" class="live-image-type" src="/static/img/live/icon_list_tag_live_history.svg" alt="" />
<!--            <span v-if="dataItem.duration_format" class="live-duration-format">{{ dataItem.duration_format }}</span>-->
        </div>
        <div class="preview-section-content-right">
            <div class="title_style">{{ dataItem.title }}</div>
            <div v-if="dataItem.live_status > 1 || dataItem.type == 2">{{ dataItem.view_count }}人观看</div>
            <div v-else>
                <span v-if="dataItem.created_at">
                    {{ dataItem.created_at.substr(0, 16) }}
                </span>
                <div v-if="dataItem.live_status === 0" :class="[dataItem.isAppointment ? 'reserved' : 'reservation']" @click.stop="liveApply(dataItem)">
                    {{ dataItem.isAppointment === 1 ? '已预约' : '一键预约' }}
                </div>
                <div v-else-if="dataItem.live_status == 1">加入</div>
            </div>
        </div>

        <Overlay ref="overlayRef" :dataItem="childrenItem"></Overlay>
    </div>
</template>

<script>
import { formatDate } from '@/util/date.js'
import Interface from '@/util/interface.js'
import Overlay from './overlay.vue'
export default {
    components: {
        Overlay
    },
    props: {
        dataItem: {
            type: Object
        }
    },
    data() {
        return {
            childrenItem: null
        }
    },
    filters: {
        formatTime: function(value) {
            return formatDate(value, 'Y年M年D日')
        },
    },
    methods: {
        // 直播-一键预约
        liveApply(item) {
            if (item.isAppointment === 0) {
                // 判断是否认证 0 未认证   1已认证
                let user = localStorage.getItem('user')
                let is_complete = JSON.parse(user).is_complete

                if (is_complete == 1) {
                    Interface.getData('get', Interface.v4.apply + '/' + item.id).then(res => {
                        if (res.code == 0) {
                            this.childrenItem = null
                            this.childrenItem = item
                            this.$refs.overlayRef.applyShow = true
                            // this.fetch('homepage')
                        }
                    })
                } else {
                    // 去认证
                    this.$dialog
                        .confirm({
                            title: '需要登录',
                            message: '为了方便学习课程,需要您登录认证',
                            confirmButtonText: '去认证'
                        })
                        .then(() => {
                            sessionStorage.setItem('back-url', this.$route.path)
                            this.$router.push({ name: 'login' })
                        })
                        .catch(() => {
                            // on cancel
                        })
                }
            } else {
                Interface.goLiveDetail(this, item)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/styles/verify.scss';
.preview-section-content {
    display: flex;
    margin: 10px 10px;
    background: #ffffff;
    border-radius: 8px;
    padding: 12px;

    .preview-section-content-left {
        position: relative;

        >>> .van-image .van-image__img {
            width: 130px;
            height: 73px;
            border-radius: 6px;
        }

        .live-image-type {
            position: absolute;
            left: 0px;
            top: 0px;
        }

        .live-duration-format {
            position: absolute;
            right: 5px;
            bottom: 5px;
            font-size: 12px;
            font-family: Avenir-Heavy, Avenir;
            font-weight: 800;
            color: #ffffff;
            line-height: 16px;
        }
    }

    .preview-section-content-right {
        padding-left: 10px;
        position: relative;
        div {
            &:nth-child(1) {
                width: 191px;
                height: 40px;
                @include ContentStyle;
                line-height: 21px;
                // padding-bottom: 14px;
            }

            &:nth-child(2) {
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #9d9d9d;
                line-height: 17px;
                margin-top: 14px;
            }
        }

        .reservation {
            position: absolute;
            bottom: 0px;
            right: 0px;
            display: inline-block;
            font-size: 13px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #d81d20;
            line-height: 18px;
            background: #fff0ee;
            border-radius: 17px;
            padding: 5px 14px;
        }

        .reserved {
            position: absolute;
            bottom: 0px;
            right: 0px;
            display: inline-block;
            font-size: 13px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #907970;
            line-height: 18px;
            background: rgba(221, 221, 221, 0.3);
            border-radius: 17px;
            padding: 5px 14px;
        }
    }
}

>>> .meeting-list {
    padding: 0px !important;
    .meeting-list-meeting-item,
    .meeting-list-meeting-item-item-subject,
    .meeting-list-meeting-item-item-template-title-log,
    .meeting-list-meeting-item-item {
        // width: auto !important;
        width: 355px !important;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/live/list/live-single.vue